import React from "react";
import { BrowserRouter, Routes as RouterRoutes, Route } from "react-router-dom";
import ScrollToTop from "components/ScrollToTop";
import ErrorBoundary from "components/ErrorBoundary";
import NotFound from "pages/NotFound";
import TrainingCoursesCatalog from './pages/training-courses-catalog';
import VolunteerDashboard from './pages/volunteer-dashboard';
import VolunteerRegistration from './pages/volunteer-registration';
import LoginScreen from './pages/login-screen';
import PasswordResetEmailScreen from './pages/password-reset-email-screen';
import PasswordResetOtpVerificationScreen from './pages/password-reset-otp-verification-screen';
import PasswordResetNewPasswordScreen from './pages/password-reset-new-password-screen';
import NewPasswordCreationScreen from './pages/new-password-creation-screen';
import EditableProfileScreen from './pages/editable-profile-screen';

const Routes = () => {
  return (
    <BrowserRouter>
      <ErrorBoundary>
      <ScrollToTop />
      <RouterRoutes>
        {/* Define your route here */}
        <Route path="/" element={<TrainingCoursesCatalog />} />
        <Route path="/training-courses-catalog" element={<TrainingCoursesCatalog />} />
        <Route path="/volunteer-dashboard" element={<VolunteerDashboard />} />
        <Route path="/volunteer-registration" element={<VolunteerRegistration />} />
        <Route path="/login-screen" element={<LoginScreen />} />
        <Route path="/password-reset-email-screen" element={<PasswordResetEmailScreen />} />
        <Route path="/password-reset-otp-verification-screen" element={<PasswordResetOtpVerificationScreen />} />
        <Route path="/password-reset-new-password-screen" element={<PasswordResetNewPasswordScreen />} />
        <Route path="/new-password-creation-screen" element={<NewPasswordCreationScreen />} />
        <Route path="/editable-profile-screen" element={<EditableProfileScreen />} />
        <Route path="*" element={<NotFound />} />
      </RouterRoutes>
      </ErrorBoundary>
    </BrowserRouter>
  );
};

export default Routes;
